import axios from 'axios';

const API_PREFIX = process.env.VUE_APP_API_PREFIX
  ? process.env.VUE_APP_API_PREFIX
  : '';
const API_VER = process.env.VUE_APP_API_VERSION
  ? process.env.VUE_APP_API_VERSION
  : '';

const baseURL = API_PREFIX + API_VER;

export default axios.create({
  baseURL,
  // You can add your headers here
});
